export const getMentions = (htmlContent: string) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlContent, 'text/html')

  // Get all mention elements
  const allMentionElements = Array.from(doc.querySelectorAll('[data-type="mention"]'))

  // Separate user mentions from broadcast mentions (@everyone)
  let notifyAllGroupMembers = false
  const mentions = allMentionElements
    .filter((el) => {
      const mentionType = el.getAttribute('data-mention-type')
      const isBroadcast = mentionType === 'broadcast'

      // If it's a broadcast mention, set the flag
      if (isBroadcast) {
        notifyAllGroupMembers = true
        return false // Don't include in mentions array
      }

      return true // Include regular user mentions
    })
    .map((el) => ({
      contactId: el.getAttribute('data-id') || el.getAttribute('id') || '',
    }))

  const channelMentions = Array.from(doc.querySelectorAll('[data-type="channel-mention"]')).map(
    (el) => ({
      channelId: el.getAttribute('data-id') || el.getAttribute('id') || '',
    })
  )

  const eventMentions = Array.from(doc.querySelectorAll('[data-type="events-mention"]')).map(
    (el) => ({
      eventId: el.getAttribute('data-id') || el.getAttribute('id') || '',
    })
  )

  const courseMentions = Array.from(doc.querySelectorAll('[data-type="courses-mention"]')).map(
    (el) => ({
      courseId: el.getAttribute('data-id') || el.getAttribute('id') || '',
    })
  )

  return { mentions, channelMentions, eventMentions, courseMentions, notifyAllGroupMembers }
}
